import type { ConfigContact } from '@bb/domain/dist/types/AppointmentConfig';
import axios from 'axios';

type SaveConfigContactParams = {
  listingId: string;
  contactId: string;
};

const saveConfigContact = async (
  params: SaveConfigContactParams,
  body: ConfigContact,
) => {
  const { data } = await axios.request({
    url: `/appointments/${params.listingId}/config/contacts/${params.contactId}`,
    method: 'post',
    data: body,
  });

  return data;
};

export default saveConfigContact;
